import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  ValidatorFn
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import { of } from "rxjs";
import { ExcelFileDownloadServices } from "../../vdms/vdms_shared/utils/excelDownload.services";

@Component({
  selector: "app-assign-user",
  templateUrl: "./assign-user.component.html",
  styleUrls: ["./assign-user.component.css"]
})
export class AssignUserComponent implements OnInit {
  displayUserValue: Number = 0;
  assignUserList: any = [];
  emp_Data: any = [];
  assignUserFm: FormGroup;
  submitted = false;
  mode: any;
  checkboxCount = false;
  isValid: any = true;
  errorMessage: any;
  ordersData = [];
  statusData: any = [
    { id: 1, name: "ACTIVE" },
    { id: 2, name: "INACTIVE" }
  ];

  sortKey: string = 'sno'; //set default
  sortReverse: boolean = false;

  noOfItems = 10;

  delID: String;


  filteredData: any = [];
  columnfilter = {
    user_name: {
      singleSelection: false,
      idField: "user_name",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    name: {
      singleSelection: false,
      idField: "name",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search User Name.",
    },
    email: {
      singleSelection: false,
      idField: "email",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Email.",
    },
    assign_mode: {
      singleSelection: false,
      idField: "assign_mode",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Assign Mode.",
    },
    status: {
      singleSelection: false,
      idField: "status",
      textField: "status",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Status.",
    }
  }

  userFilterData = [];
  userNameFilterData = [];
  emailFilterData = [];
  assignModeFilterData = [
    'CAR_MAINTENANCE',
    'DRIVER_FEEDBACK',
    'HOUSE_MAINTENANCE',
    'HOUSE_RELOCATION',
    'DRIVER_ATTENDANCE'
  ];
  statusFilterData = [
    'ACTIVE',
    'INACTIVE'
  ];

  userFilterModel: any = new Array();
  userNameFilterModel: any = new Array();
  emailFilterModel: any = new Array();
  assignModeFilterModel: any = new Array();
  statusFilterModel: any = new Array();

  // File Upload
  file: File;
  uploadList = [];
  statusList = [];
  uploadStatus: number = 0;
  progresspercent: number = 0;
  displayValue: number = 0;
  arrayBuffer: any;
  sheetlength: number = 0;
  cnt: number = 1;
  enableUploadBtn: boolean = false;
  @ViewChild('uploadFile') uploadFile: ElementRef;
  @ViewChild('closeUploadModalBtn') closeuploadModalBtn: ElementRef;


  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder,
    public excelFileDownloadServices: ExcelFileDownloadServices,
  ) {
    this.getAllData();
  }

  // GET DATA FROM ASSIGNED USER
  getAllData() {
    console.log("GET CAR LIST");
    this.assignUserList = []
    this.awserviceProvider.getAssignUserList().then(data => {
      this.constructData(data);
      console.log("response", data);
    });
  }

  constructData(data) {
    this.assignUserList = []
    var oplist = []
    let responseData = data;
    responseData.sort((a, b) => {
      // Handle null/undefined dates
      if (!a.created_date && !b.created_date) return 0;
      if (!a.created_date) return 1; // Put items without dates at the end
      if (!b.created_date) return -1; // Put items without dates at the end

      // Convert dates to timestamps for comparison
      const dateA = new Date(a.created_date).getTime();
      const dateB = new Date(b.created_date).getTime();

      // Handle invalid dates
      if (isNaN(dateA) && isNaN(dateB)) return 0;
      if (isNaN(dateA)) return 1;
      if (isNaN(dateB)) return -1;

      return dateB - dateA; // Descending order (newest first)
    });
    for (var i in responseData) {
      responseData[i].sno = +i + 1;
      oplist.push(responseData[i])
    }

    this.assignUserList = oplist;

    this.filteredData = [...this.assignUserList];
    this.initializeFilterData();
  }

    private pushIfValid(arr: any[], value: any): void {
    if (value != null && !arr.includes(value)) {
      arr.push(value);
    }
  }

    initializeFilterData() {
    console.log('initializeFilterData', this.assignUserList)
    // Clear the filter data arrays

    this.userFilterData = [];
    this.userNameFilterData = [];
    this.emailFilterData = [];


    // const insuranceStatus = this.stringToDateAndRenewalPipe.transform(dSheets.policy_to);
    // const leaseStatus = this.stringToDateAndRenewalPipe.transform(dSheets.lease_to);
    // Populate the filter data arrays
    for (const item of this.assignUserList) {

      this.pushIfValid(this.userFilterData, item.user_name);
      this.pushIfValid(this.userNameFilterData, item.name);
      this.pushIfValid(this.emailFilterData, item.email);

    }



    // Update dropdown data with proper change detection
    const updateDropdownData = () => {
      this.userFilterData = [...this.userFilterData];
      this.userNameFilterData = [...this.userNameFilterData];
      this.emailFilterData = [...this.emailFilterData];

      console.log('updateDropdownData', this.userFilterData);

    };


    updateDropdownData();
  }

  onFilterChange() {
    console.log('onfilterchange', this.assignUserList)

    if (this.assignUserList.length) {
      const filtered = this.assignUserList.filter(vehicle => {

        // Helper function to check if a value matches the filter
        const matchesFilter = (filter: any[], value: any) =>
          !filter.length || filter.includes(value);

        const matchesFilter1 = (filter: any[], value: any) =>
          !filter.length || filter.some(item => value.includes(item));

        // Checking if the vehicle matches all filters
        const matchuserRN = matchesFilter(this.userFilterModel, vehicle.user_name)
        const matchuserName = matchesFilter(this.userNameFilterModel, vehicle.name)
        const matchemail = matchesFilter(this.emailFilterModel, vehicle.email)
        const matchAssignMode = matchesFilter1(this.assignModeFilterModel, vehicle.assign_mode)
        const matchStatus = matchesFilter(this.statusFilterModel, vehicle.status)

        console.log(matchAssignMode, this.assignModeFilterModel, vehicle.assign_mode.join(', '));

        // Return true only if all criteria match
        return (
          matchuserRN &&
          matchuserName &&
          matchemail &&
          matchAssignMode &&
          matchStatus
        );

      });


      if (filtered.length > 0) {
        this.filteredData = filtered
      }

    }

  }

  searchRnId() {
    if (this.assignUserFm.value.rn_num !== "") {
      this.awserviceProvider
        .filterRnUserExist(this.assignUserFm.value.rn_num)
        .then(result => {
          console.log("RnExist", result.length);
          if (result.length === 0) {
            this.rnIdSearch();
            this.isValid = false;
          } else {
            this.emp_Data = [];
            this.isValid = true;
            this.errorMessage = "User already Exists!";
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    } else {
      this.errorMessage = "Please Enter RN Number...";
    }
  }

  rnIdSearch() {
    this.emp_Data = [];
    console.log("searching.....", this.assignUserFm.value.rn_num);
    this.awserviceProvider
      .rnUserFilter(this.assignUserFm.value.rn_num)
      .then(result => {
        console.log("data-rn-user", result);
        if (result.length === 0) {
          this.errorMessage = "Please Enter Valid RN Number...";
        } else {
          this.errorMessage = "";
          this.emp_Data = result;
          console.log("ORDERS", this.ordersData);
          this.assignUserFm.patchValue({
            id: "",
            rn_num: this.emp_Data[0].user_name,
            user_name: this.emp_Data[0].user_name,
            name: this.emp_Data[0].name,
            email: this.emp_Data[0].email_address,
            phone: this.emp_Data[0].employee_phone,
            assign_mode: "",
            status: ""
          });
        }
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  // ADD DATA
  add() {
    this.isValid = true;
    this.errorMessage = "";
    this.displayUserValue = 1;
    this.mode = "add";
    this.emp_Data = [];
    this.formInitilization();
    console.log("this.assignUserFm.value", this.assignUserFm.value);
  }

  formInitilization() {
    console.log("formInitilization");
    this.assignUserFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      user_name: [""],
      name: [""],
      email: [""],
      phone: [""],
      status: ["", [Validators.required, Validators.min(1)]],
      // orders: new FormArray([])
      orders: new FormArray([], this.minSelectedCheckboxes(1))
    });
    of(this.getOrders()).subscribe(orders => {
      this.ordersData = orders;
      this.addCheckboxes();
    });
  }

  minSelectedCheckboxes(min = 1) {
    const validators: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        // get a list of checkbox values (boolean)
        .map(control => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      if (totalSelected === 0) {
        this.checkboxCount = true;
      } else {
        this.checkboxCount = false;
      }
      // if the total is not greater than the minimum, return the error message
      return totalSelected >= min ? null : { required: true };
    };
    console.log("thiru", validators);
    return validators;
  }

  get f() {
    return this.assignUserFm.controls;
  }

  editformInitilization() {
    console.log("formInitilization");
    // this.assignUserFm = new FormGroup({
    //   id: new FormControl(""),
    //   rn_num: new FormControl(""),
    //   user_name: new FormControl(""),
    //   name: new FormControl(""),
    //   email: new FormControl(""),
    //   phone: new FormControl(""),
    //   // assign_mode: new FormControl(""),
    //   status: new FormControl(""),
    //   orders: new FormArray([])
    // });
    this.assignUserFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      user_name: [""],
      name: [""],
      email: [""],
      phone: [""],
      status: ["", [Validators.required, Validators.min(1)]],
      // orders: new FormArray([])
      orders: new FormArray([], this.minSelectedCheckboxes(1))
    });
    of(this.getOrders()).subscribe(orders => {
      this.ordersData = orders;
    });
  }

  getOrders() {
    return [
      { id: "CAR_MAINTENANCE", name: "Car Maintenance" },
      { id: "DRIVER_FEEDBACK", name: "Driver Feedback" },
      { id: "HOUSE_MAINTENANCE", name: "House Maintenance" },
      { id: "HOUSE_RELOCATION", name: "House Relocation" },
      { id: "DRIVER_ATTENDANCE", name: "Drive Attendance" },
    ];
  }

  addCheckboxes() {
    this.ordersData.forEach((o, i) => {
      console.log("0", o.id);
      // const control = new FormControl(i === 0); // if first item set to true, else false
      (this.assignUserFm.controls.orders as FormArray).push(
        new FormControl(false)
      );
    });
  }

  /* On Submit */
  // SAVE DATA
  onSubmit() {
    console.log("save btn clicked");
    console.log("onSubmit.....", this.assignUserFm.value);

    this.submitted = true;
    if (this.assignUserFm.invalid) {
      return;
    }

    this.errorMessage = "";
    const selectedOrderIds = this.assignUserFm.value.orders
      .map((v, i) => (v ? this.ordersData[i].id : null))
      .filter(v => v !== null);
    console.log("selectedOrderIds", selectedOrderIds);

    if (this.assignUserFm.value.id !== "") {
      // UPDATE
      console.log("update");
      var test2 = {
        id: this.assignUserFm.value.id,
        user_name: this.assignUserFm.value.user_name,
        name: this.assignUserFm.value.name,
        email: this.assignUserFm.value.email,
        phone: this.assignUserFm.value.phone,
        //assign_mode: this.assignUserFm.value.assign_mode,
        assign_mode: selectedOrderIds,
        status: this.assignUserFm.value.status
      };

      // # UPDATE RECORD #
      this.awserviceProvider
        .userAssignData(test2)
        .then(result => {
          this.findByIdRncUser(test2.user_name);
          // this.sendEmail(result);
          // this.getAllData();
          // this.displayUserValue = 0;
          // this.mode = "";
          // this.isValid = true;
          // console.log("update-result", result);
        })
        .catch(err => {
          console.log("err", err);
        });
    } else {
      // CREATE
      var test1 = {
        user_name: this.assignUserFm.value.user_name,
        name: this.assignUserFm.value.name,
        email: this.assignUserFm.value.email,
        phone: this.assignUserFm.value.phone,
        // assign_mode: this.assignUserFm.value.assign_mode,
        assign_mode: selectedOrderIds,
        status: this.assignUserFm.value.status
      };

      // # CREATE RECORD #
      this.awserviceProvider
        .CreateUserAssign(test1)
        .then(resultData => {
          this.findByIdRncUser(test1.user_name);
          // this.sendEmail(resultData); // email feature remove temporarily
          // this.getAllData();
          // this.displayUserValue = 0;
          // this.mode = "";
          // this.isValid = true;
          // console.log("resultData-test", resultData);
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }
  /* On Submit */

  sendEmail(data) {
    console.log("tttttttttttttttt", data.assign_mode);
    var text = "";
    this.ordersData
      .filter(temp => data.assign_mode.includes(temp.id))
      .forEach(res => {
        text += "<li>" + res.name + "</li>";
      });
    // for (var i = 0; i < this.ordersData.length; i++) {
    //   var test = data.assign_mode.includes(this.ordersData[i].id);
    //   if (test) {
    //     text += "<li>" + this.ordersData[i].name + "</li>";
    //   }
    // }
    console.log(text);
    var dataValue = {
      email_address: data.email,
      name: data.name,
      mode: text
    };
    this.awserviceProvider.sendEmailService(dataValue).subscribe(
      data => {
        console.log("data", data);
        // alert("Succesfully Sent Email");
      },
      Error => {
        console.log("Error", Error);
        // alert("failed while Sending Email");
      }
    );
  }

  editData(userdata) {
    console.log("userdata", userdata);
    this.displayUserValue = 1;
    this.submitted = false;
    this.mode = "edit";
    this.isValid = false;
    this.errorMessage = "";
    this.editformInitilization();
    /* checkbox Value */
    this.ordersData.map(localCheckBox => {
      console.log("localCheckBox", localCheckBox.id);
      if (userdata.assign_mode.includes(localCheckBox.id)) {
        (this.assignUserFm.controls.orders as FormArray).push(
          new FormControl(true)
        );
      } else {
        (this.assignUserFm.controls.orders as FormArray).push(
          new FormControl(false)
        );
      }
    });
    /* checkbox Value */

    this.assignUserFm.patchValue({
      id: userdata.id,
      rn_num: "",
      user_name: userdata.user_name,
      name: userdata.name,
      email: userdata.email,
      phone: userdata.phone,
      assign_mode: userdata.assign_mode,
      status: userdata.status
    });

    // this.f["id"].setValue(vendorDt.id);
    // this.f["name"].setValue(vendorDt.name);
    // this.f["email"].setValue(vendorDt.email);
    // this.f["phone"].setValue(vendorDt.phone);
    // this.f["address"].setValue(vendorDt.address);
    // this.f["vendor_type"].setValue(vendorDt.vendor_type);
    // this.f["is_active"].setValue(vendorDt.is_active);
    // console.log("pop", this.assignUserFm);
  }

  findByIdRncUser(user_name) {
    this.awserviceProvider
      .findUserByUserName(user_name)
      .then(result => {
        console.log("THIRU", result);
        this.updateRnUser(result[0].id);
      })
      .catch(err => {
        console.log("findByIdRncUser-err", err);
      });
  }
  updateRnUser(id) {
    console.log("pid", id);
    var id = id;
    var user_type = 6;
    this.awserviceProvider
      .updateRncUserAssignType(id, user_type)
      .then(res => {
        console.log("updateRnUser", res);
        this.getAllData();
        this.displayUserValue = 0;
        this.mode = "";
        this.isValid = true;
      })
      .catch(err => {
        console.log("updateRnUser-err", err);
      });
  }

  ngOnInit() {
    this.displayUserValue = 0;
    this.mode = "";
    this.formInitilization();
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return 'fa fa-sort-desc';
      }
      else {
        return 'fa fa-sort-asc';
      }
    }
    else {
      return 'fa fa-sort';
    }

  }

  deletePopup(user) {
    this.delID = user.id;
  }

  deleteData(userDt) {
    this.awserviceProvider
      .deleteUserData(userDt)
      .then((res) => {
        this.delID = "";
        console.log("DeleteID", this.delID);
        this.getAllData();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  incomingfile(event) {
    this.uploadStatus = -1;
    this.file = event.target.files[0];
    this.enableUploadBtn = true;
  }

  isInvalid(str) {
    if (str == 'undefined' || str == null || str.length < 1 || str.length == 0)
      return true;
    else
      return false;
  }

  uploadUser() {
    if (this.file == undefined) {
      return;
    }

    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      this.sheetlength = sheet.length;
      console.log(sheet, "sheet:::::::::::::::::::;;");
      
      this.startProcess(sheet);
    }
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }


  async startProcess(sheet) {
    let assignMode = this.getOrders();
    for (const dict of sheet) {

      var s_no = String(dict["S.No"]).trim();
      var rn_num = String(dict["RN Number"]).trim();
      var assign_mode = String(dict["Assign Mode"]).trim().split(',');
      var status = String(dict["Status"]).trim();

      let userData = {
        id: "",
        s_no: s_no,
        rn_num: rn_num,
        assign_mode: assign_mode,
        status: status
      }

      var errorText = ""

      if (this.isInvalid(userData.rn_num)) {
        errorText = errorText + 'Invalid Vehicle Number :: '
      } else {
        var findrnUser = await this.awserviceProvider.filterRnUserExist(userData.rn_num);

        if (findrnUser.length > 0) {
          errorText = errorText + 'User Already Exists :: '
        } else {
          var rnUser = await this.awserviceProvider.rnUserFilter(userData.rn_num);
          if (rnUser.length == 0) {
            errorText = errorText + 'Invalid RN Number :: '
          } else {
            userData['user_name'] = rnUser[0].user_name;
            userData['name'] = rnUser[0].name;
            userData['email'] = rnUser[0].email_address;
            userData['phone'] = rnUser[0].employee_phone;
          }
        }
      }

      if (this.isInvalid(userData.assign_mode)) {
        errorText = errorText + 'Invalid Assign Mode :: '
      }

      if (userData.assign_mode.length == 0) {
        errorText = errorText + 'Assign Mode is Empty :: '
      } else {
        for (var i = 0; i < userData.assign_mode.length; i++) {
          if (!assignMode.some(item => item.name === userData.assign_mode[i].trim())) {
            errorText = errorText + 'Invalid Assign Mode :: ' + userData.assign_mode[i] + ' :: '
          } else {
            userData.assign_mode[i] = assignMode.find(item => item.name === userData.assign_mode[i].trim()).id;
          }
        }
      }

      if (this.isInvalid(userData.status)) {
        errorText = errorText + 'Invalid Status :: '
      } else {
        if (userData.status != 'ACTIVE' && userData.status != 'INACTIVE') {
          errorText = errorText + 'Invalid Status :: '
        }
      }


      if (errorText.length > 0) {
        // console.log("----------" + errorText)
        this.statusList.push({ line_no: s_no, status: 'Error', error: errorText });
        this.displayValue = 1;
        this.uploadStatus = 3;
      } else {
        this.uploadList.push(userData)
        this.progressIncrement();
      }

    }

    if (this.statusList.length == 0 && this.uploadList.length > 0) {
      // console.log('inside if');
      for (var i = 0; i < this.uploadList.length; i++) {
        var item = this.uploadList[i];
        this.OnSaveUser(item, i);
      }
    }
  }

  closeModal() {
    this.closeuploadModalBtn.nativeElement.click();
    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  async OnSaveUser(value, i) {
    await this.awserviceProvider.CreateUserAssign(value);
    this.findByIdRncUser(value.user_name);
    if (i == this.uploadList.length - 1) {
      this.closeModal();
    }
  }

  progressIncrement() {
    if (this.cnt == this.sheetlength) {
      this.uploadStatus = 2;
    }

    this.progresspercent = this.cnt * 50 / this.sheetlength;
    this.cnt++;
  }

  resetFile() {
    this.uploadFile.nativeElement.value = null;
    this.file = undefined;
    this.enableUploadBtn = false;
    this.uploadStatus = 0;

    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;

  }

  downloadUserModule() {
    let dataSheet: any[] = [];
    let download: any[] = this.filteredData;
    let assignMode = this.getOrders();
     for (const sheet of download) {
     let dataRecord = {
        user_name: sheet.user_name,
        name: sheet.name,
        email: sheet.email,
        phone: sheet.phone,
        assign_mode: sheet.assign_mode,
        status: sheet.status
      };

      for (var i = 0; i < sheet.assign_mode.length; i++) {
        dataRecord.assign_mode[i] = assignMode.find(item => item.id === dataRecord.assign_mode[i].trim()).name;
      }
      dataRecord.assign_mode = dataRecord.assign_mode.join(', ');
      dataSheet.push(dataRecord);
     }

    this.excelFileDownloadServices.downloadExcel(dataSheet);
  }

}
